//routes/index.js
import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loading } from '../components';
import { useAuth } from '../hooks';

// 首屏静态加载：公开路由，保证秒开
import AuthPage from '../pages/auth';
import Office from '../pages/home/office';

// 登录后一级模块：按需加载
const Personal = lazy(() => import('../pages/home/personal'));
const Profile = lazy(() => import('../pages/profile'));
const MusicModule = lazy(() => import('../pages/home/lifehub/music'));
const AccountingModule = lazy(() => import('../pages/home/lifehub/accounting'));
const WechatModule = lazy(() => import('../pages/home/lifehub/wechat'));
const SportModule = lazy(() => import('../pages/home/lifehub/sport'));
const WorkModule = lazy(() => import('../pages/home/lifehub/work'));

function ProtectedRoute() {
  const { isAuthenticated, authChecked } = useAuth();
  const location = useLocation();

  if (!authChecked) {
    return <Loading message="正在检查登录状态..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace state={{ from: location }} />;
  }

  return <Outlet />;
}

function LazyOutlet() {
  return (
    <Suspense fallback={<Loading message="模块加载中..." />}>
      <Outlet />
    </Suspense>
  );
}

function AppRoutes() {
  return (
    <Routes>
      {/* 公开路由：首屏就能打开 */}
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/office" element={<Office />} />
   
      {/* 登录后模块 */}
      <Route element={<ProtectedRoute />}>
        <Route element={<LazyOutlet />}>
          <Route path="/personal" element={<Personal />} />
          <Route path="/profile" element={<Profile />} />

          {/* 关键：这里不是具体页面，而是“模块入口” */}
          <Route path="/music/*" element={<MusicModule />} />
          <Route path="/accounting/*" element={<AccountingModule />} />
          <Route path="/wechat/*" element={<WechatModule />} />
          <Route path="/sport/*" element={<SportModule />} />
          <Route path="/work/*" element={<WorkModule />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/office" replace />} />
    </Routes>
  );
}

export default AppRoutes;